import React from 'react';
import TabBar from "../../TabBar";
import { inject, observer } from "mobx-react/index";

@observer
class VisitHome extends React.Component {
  render() {
    return (
      <div>
        <TabBar
          items={[
            { to: '/monitoring/survey/create', label: 'Create' },
            { to: '/monitoring/survey/history', label: 'History' },
            { to: '/monitoring/survey/template', label: 'Template' },
            { to: '/monitoring/survey/topic', label: 'Topic' },
            // { to: '', label: '' },
          ]}
        /><br />
        {this.props.children}
      </div>
    );
  }
}

export default VisitHome;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Survey/SurveyHome.js